var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"card-deck m-2"},[(_vm.call)?_vm._l((_vm.homeData),function(r,index){return _c('dc-vizlet',{key:index,attrs:{"dc-viz":r}})}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }